import { Box, useMediaQuery } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import { useTheme } from "@material-ui/styles";
import React, { Fragment, useContext } from "react";
import { ProcessContext } from "../../../../../contexts/ProcessContext";
import InfoBanner from "../../InfoBanner";
import MainButton from "../../MainButton";
import Text from "../../Text";
import WelcomeWizardProgressStep from "../../WelcomeWizardProgressStep";
import { ThemedAsset } from "nemuru-components";
import { AuthContext } from "../../../../../contexts/AuthContext";
import { SECTIONS } from "../../../../../config/config";
import { useWelcomeMessage } from "../hooks/useWelcomeMessage";
import { useWelcomeMessageStyle } from "../hooks/useWelcomeMessageStyle";
import { WelcomeBackMessageHeader } from "./shared/WelcomeBackMessageHeader";
import { WelcomeBackLogo } from "./shared/WelcomeBackLogo";

export default function WelcomeBackMessageWithProgress({
  showStartButton,
  onHideMessage,
}) {
  const { state: processContextState, dispatch } = useContext(ProcessContext);
  const {
    state: { agent, merchant },
  } = useContext(AuthContext);

  const { palette } = useTheme();
  const isScreenXs = useMediaQuery(useTheme().breakpoints.down("xs"));

  const {
    getProposedByValue,
    hidingLogo,
    hidingMessage,
    startApp,
    onBoardingByBorrower,
    currentProgressStepIndex,
  } = useWelcomeMessage({ onHideMessage, processContextState, dispatch });

  const { itemsStyle } = useWelcomeMessageStyle({
    hidingMessage,
  });

  return (
    <Fragment>
      <WelcomeBackMessageHeader
        hidingLogo={hidingLogo}
        hidingMessage={hidingMessage}
      />
      {hidingLogo && (
        <>
          <WelcomeBackLogo />
          <Box>
            <Typography
              variant={isScreenXs ? "h6" : "h4"}
              style={{
                ...itemsStyle,
                color: palette.text.title,
              }}
            >
              <strong>
                <Text tId="LETS_GO" />
              </strong>
            </Typography>
            <Typography
              variant={isScreenXs ? "subtitle1" : "h5"}
              className={"mb-3 transition-all"}
              color="primary"
              style={itemsStyle}
            >
              <strong>
                <Text tId="YOUR_LOAN_PROCESS" />
              </strong>
            </Typography>
          </Box>

          <Box mb={3}>
            {Object.keys(processContextState.sectionsArray).map((item, i) => {
              return (
                <WelcomeWizardProgressStep
                  key={i}
                  stepIndex={i}
                  currentProgressStepIndex={currentProgressStepIndex}
                  icon={
                    <ThemedAsset
                      id={processContextState.sectionsArray[item].titleIconName}
                      width={35}
                      height={35}
                      style={{ color: palette.secondary.main }}
                    />
                  }
                  currentSectionProgress={
                    processContextState.currentSectionProgress
                  }
                  section={processContextState.sectionsArray[item].id}
                  currentSection={processContextState.currentSection}
                />
              );
            })}
          </Box>

          <Box pb={"16px"}>
            {onBoardingByBorrower && (
              <InfoBanner
                assetType={processContextState.loan?.asset_reference[0].type}
                proposedBy={getProposedByValue({ agent, merchant })}
              />
            )}
            {showStartButton && (
              <MainButton onClick={() => startApp()}>
                {processContextState.currentSection ? (
                  <Text
                    tId={
                      SECTIONS[processContextState.currentSection.id]
                        .startButtonTextId
                    }
                  />
                ) : (
                  <Text tId="RESUME" />
                )}
              </MainButton>
            )}
          </Box>
        </>
      )}
    </Fragment>
  );
}
